import Images from '../../../../../../../../components/Commons/Images';
import CustomCard from '../../../../../../../../v2-components/Antd/Card';
import { Button, Row, Col, Typography } from 'antd';
import '../../style.scss';
import { Enviroment } from '../../../../../../../../_config/constants/enviroment-v2.constant';
import { ENV_IMG_STATIC } from '../../../../../../../../components/Commons/Hooks/Variables/Enviroment';
import { ENVIROMENT } from '../../../../../../../../v2-config/constants/enviroment.constant';
import { Icons } from '../../../../../../../../v2-components/CardProduct/constant/icons.constant';
import AddProductCart from '../../../../../../../../components/Commons/Hooks/Functions/AddProductCart';
import { handleMecanic } from '../../handle/mecanic.handle';
import { useEffect, useState } from 'react';
import { image } from '../../constants/image.constant';
import { handleOriginalImage } from '../../../../../../../../v2-components/CardProduct/handle/original-image.handle';
import CustomImage from '../../../../../../../../v2-components/Antd/Image';
import Notify from '../../../../../../../../components/Commons/Notify';
const { Text, Paragraph } = Typography;

// ProductosMagistralItem.jsx
export const ProductosMagistralItem = ({ item, index, handleTypeRecipes, pharmacy_icon, selectedCheckboxes, handleCheckboxChange, status_tracking }) => {
	const productCommercialType = item.product_type === 'COMERCIAL' ? true : false;
	const { handleAddProductCart } = AddProductCart();
	const itemCart = {
		...item,
		...item.product_detail,
	};
	const [imageSrc, setImageSrc] = useState(item.product_detail.image);
	const [quotationToken, setQuotationToken] = useState(null);

	useEffect(() => {
		setImageSrc(item.product_detail.image);
	}, [item.product_detail.image]);

	const handleImageError = () => {
		setImageSrc(image.default);
	};

	const handleAddToCart = () => {
		if (quotationToken && itemCart.interface_quotation?.quotation_token !== quotationToken) {
			// Si los `quotation_token` no coinciden, mostramos la notificación
			Notify({
				title: `Ups!`,
				colorTitle: 'ph-main-notification-error-title',
				description: `Tienes una cotización abierta, puedes pagarla o borrar los productos de la bolsa para agregar productos de una nueva cotización.`,
				time: 8,
				image: 'warning',
				placement: 'topRight',
			});
		} else {
			// Si coinciden, seguimos el flujo normal
			handleAddProductCart(itemCart, item.quantity, false);
		}
	};

	useEffect(() => {
		const cartNow = JSON.parse(localStorage.getItem('cart')) || [];
		let token = null;

		// Buscar `quotation_token` en el carrito
		cartNow.forEach((item) => {
			if (item.interface_quotation) {
				token = item.interface_quotation.quotation_token;
			}
		});

		if (token) {
			setQuotationToken(token); // Guardar el `quotation_token` encontrado en el carrito
		}
	}, []); // Solo se ejecuta una vez al montar el componente

	console.log('lala itemCart', itemCart);

	return (
		<div>
			<div className="producto-info">
				<span className="checkbox-col">
					{status_tracking.status !== 100 && (
						<input type="checkbox" checked={selectedCheckboxes.includes(index)} onChange={() => handleCheckboxChange(index)} />
					)}
				</span>
				Producto:
				<Paragraph className="producto-description">{productCommercialType ? item.product_detail.sub_category : item.name}</Paragraph>
			</div>
			<div>Cantidad: {item.quantity}</div>

			<CustomCard className="producto-card">
				{itemCart.promotions && (
					<Images
						classContent={'ph-modal-types-recipe-container-i'}
						classImage={'ph-modal-types-recipe-container-i'}
						default={Icons[ENVIROMENT.COUNTRY].promotion_tag}
						webp={`${ENV_IMG_STATIC}/type-recipes/Icon-wp-recipes.webp`}
						jp2={`${ENV_IMG_STATIC}/type-recipes/Icon-wp-recipes.jp2`}
						jxr={`${ENV_IMG_STATIC}/type-recipes/Icon-wp-recipes.jxr`}
						title={'Type Recipes icon presentacion de receta'}
						alt={'Type Recipes icon presentacion de receta'}
					/>
				)}
				<Row gutter={16} align="middle">
					<Col span={6}>
						<div className="producto-image">
							{/* <img src={productCommercialType ? item.product_detail.image : magistralIcon} alt="Producto" width={80} height={80} /> */}
							<CustomImage src={handleOriginalImage(imageSrc)} onError={handleImageError} />
						</div>
					</Col>
					<Col span={18}>
						<div className="producto-details">
							<p className="producto-tipo">{productCommercialType ? item.product_detail.laboratory : 'Recetario magistral'}</p>
							{productCommercialType ? item.product_detail.editable_name : item.name}

							<div className="farmacia-wrapper">
								<img src={pharmacy_icon} alt="pharmacy_icon" className="farmacia-icon" />
								<Text className="farmacia-text">{Enviroment.ROOT_NAME}</Text>
							</div>
						</div>
					</Col>
				</Row>

				<Row justify="space-between" className="producto-footer">
					<div onClick={handleTypeRecipes}>
						<Images
							classContent={'ph-modal-types-recipe-container-i'}
							classImage={'ph-modal-types-recipe-container-i'}
							default={Icons[ENVIROMENT.COUNTRY].MRE}
							webp={`${ENV_IMG_STATIC}/type-recipes/Icon-wp-recipes.webp`}
							jp2={`${ENV_IMG_STATIC}/type-recipes/Icon-wp-recipes.jp2`}
							jxr={`${ENV_IMG_STATIC}/type-recipes/Icon-wp-recipes.jxr`}
							title={'Type Recipes icon presentacion de receta'}
							alt={'Type Recipes icon presentacion de receta'}
						/>
					</div>

					<div>
						<div className="price-add-wrapper">
							<span>
								{(item?.product_detail?.promotion_price && itemCart.promotions) || (item?.product_detail?.quotation_price.have_discount) ? (
									<>
										{handleMecanic(itemCart, 'own-mecanic-mobile')}
										<Text style={{ color: 'gray', textDecoration: 'line-through' }}>${item.product_detail?.quotation_price?.have_discount ? item?.product_detail?.quotation_price?.base_unit_price : item.price} </Text>
										<Text strong className="precio">
											${item?.product_detail?.quotation_price?.have_discount ? item.product_detail?.quotation_price?.final_unit_price : item.product_detail?.promotion_price}{' '}										</Text>
									</>
								) : (
									<Text strong className="precio">
										${item.price}{' '}
									</Text>
								)}

								<Text className="precio-unit">c/u</Text>
							</span>

							<Button
								onClick={() => handleAddToCart()}
								style={item?.product_detail?.stock > 0 ? {} : { backgroundColor: 'grey' }}
								type="primary"
								className="agregar-btn"
								disabled={item?.product_detail?.stock > 0 ? false : true}
							>
								Agregar
							</Button>
						</div>
					</div>
				</Row>
			</CustomCard>
			<p style={{ marginBottom: '0px' }}>{item.product_detail.stock > 0 ? 'Con stock' : 'Sin stock'}</p>
		</div>
	);
};
